<template>
  <el-checkbox-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-checkbox-button
      v-for="quality in QualityTypeLabels"
      :key="quality.type_id"
      :value="quality.type_id"
    >
      {{ quality.label }}
    </el-checkbox-button>
  </el-checkbox-group>
  <el-select
    v-else
    v-model="value"
    :disabled="disabled"
    multiple
    @update:modelValue="update"
  >
    <el-option
      v-for="quality in QualityTypeLabels"
      :key="quality.type_id"
      :label="quality.label"
      :value="quality.type_id"
    >
      {{ quality.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { QualityTypeLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'QualitySelector',
  props: {
    modelValue: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      context.emit('update:modelValue', newValue)
    }

    const { isDesktop } = useResize()

    return { update, isDesktop, QualityTypeLabels, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
}
</style>
